import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.push.js";
import $ from 'jquery';
import { unbind } from '@/api/vehicleControl';
import { verificationCode } from '@/api/user';
import { isPhone, isEmail } from '@/utils/validate';
var sha256 = require('js-sha256');
export default {
  data: function data() {
    return {
      isActive: false,
      userName: '',
      verificationCode: '',
      userVerificationCode: '',
      vin: '',
      countryCode: localStorage.getItem('countryCode') || '+86'
    };
  },
  created: function created() {
    this.countryCode = localStorage.getItem('countryCode');
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},
  methods: {
    input: function input() {
      if (this.userName.trim() !== '' && this.vin.trim() !== '' && this.verificationCode.trim() !== '' && this.userVerificationCode.trim() !== '') {
        if (isPhone(this.userName) || isEmail(this.userName)) {
          this.isActive = true;
        } else {
          this.isActive = false;
        }
      } else {
        this.isActive = false;
      }
    },
    focus: function focus(dom) {
      $(dom).css('border-image', '-webkit-linear-gradient(#6EDCF5 0%, #6EDCF5 100%) 0 0 100 0');
    },
    blur: function blur(dom) {
      $(dom).css('border-image', 'none');
    },
    confirm: function confirm() {
      var _this = this;
      var params = {};
      params.userName = this.userName;
      params.verificationCode = this.verificationCode;
      params.userVerificationCode = this.userVerificationCode;
      params.vin = sha256(this.vin);
      if (this.userName.trim() !== '' && this.vin.trim() !== '' && this.verificationCode.trim() !== '' && this.userVerificationCode.trim() !== '') {
        if (isPhone(this.userName)) {
          params.countryCode = this.countryCode;
        } else {
          if (isEmail(this.userName)) {
            delete params.countryCode;
          } else {
            this.$toast('用户名格式不正确');
            return;
          }
        }
      } else {
        this.$toast('请输入完整信息');
        return;
      }
      unbind(params).then(function (res) {
        if (res.code === 0) {
          _this.$toast('发送完成');
        } else {
          _this.$toast(res.message);
        }
      });
    },
    sendCar: function sendCar() {
      var _this2 = this;
      var params = {};
      params.targetName = this.vin;
      params.operationType = 6;
      params.targetType = 3;
      if (this.vin !== '') {
        verificationCode(params).then(function (res) {
          if (res.code === 0) {
            _this2.$toast('发送完成');
          } else {
            _this2.$toast(res.message);
          }
        });
      } else {
        this.$toast('vin号不能为空');
      }
    },
    send: function send() {
      var _this3 = this;
      var params = {};
      params.targetName = this.userName;
      params.operationType = 0;
      if (isPhone(this.userName)) {
        params.countryCode = this.countryCode;
        params.targetType = 1;
      } else {
        if (isEmail(this.userName)) {
          params.targetType = 2;
          delete params.countryCode;
        } else {
          if (this.userName) {
            this.$toast('用户名格式不正确');
          } else {
            this.$toast('请输入用户名');
          }
          return;
        }
      }
      verificationCode(params).then(function (res) {
        if (res.code === 0) {
          _this3.$toast('发送完成');
        } else {
          _this3.$toast(res.message);
        }
      });
    },
    getCountry: function getCountry() {
      this.$router.push({
        path: '/selectCountry'
      });
    },
    back: function back() {
      this.$router.back();
    },
    toLogin: function toLogin() {
      this.$router.push({
        path: '/login'
      });
    }
  }
};